export default __webpack_public_path__ + "static/media/menu-banner-03.b81350b1.jpg";